import { en, fr, es, pt } from "./dict1";
import { de, it, ar, zh } from "./dict2";
import { hi, ru, ja, ko } from "./dict3";

export const dict = { en, fr, es, pt, de, it, ar, zh, hi, ru, ja, ko };

export const LANGS = [
  { code: "en", name: "English" },
  { code: "fr", name: "Français" },
  { code: "es", name: "Español" },
  { code: "pt", name: "Português" },
  { code: "de", name: "Deutsch" },
  { code: "it", name: "Italiano" },
  { code: "ar", name: "العربية" },
  { code: "zh", name: "中文" },
  { code: "hi", name: "हिन्दी" },
  { code: "ru", name: "Русский" },
  { code: "ja", name: "日本語" },
  { code: "ko", name: "한국어" },
];

export const DEFAULT_LANG = "en";
